import { render, staticRenderFns } from "./snooze-ticket.vue?vue&type=template&id=4ab27124&scoped=true&"
import script from "./snooze-ticket.vue?vue&type=script&lang=js&"
export * from "./snooze-ticket.vue?vue&type=script&lang=js&"
import style0 from "./snooze-ticket.vue?vue&type=style&index=0&id=4ab27124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab27124",
  null
  
)

export default component.exports